<template>
  <div class="second-step-to-chanel">
    <div class="tips-card">
      <div class="subtitle">{{$t('Precautions')}}</div>
      <p class="tips-p"
         v-for="(item,index) in currentWithdrawInfo.descs"
         :key="index"
      >{{item}}</p>
    </div>
    <div class="bgc-bar"></div>
    <div class="bottom-box">
      <div class="nav-title">{{$t('Payee')}}</div>
      <withdraw-or-out-commission-chanel-card
        ref="commissionChanelcard"
        :current-withdraw-info="currentWithdrawInfo"
        :key="keyvalue"
        @add-collection="addCollection"
      ></withdraw-or-out-commission-chanel-card>
      <div class="nav-title amount">{{$t('Commission_can_be_withdrawn')}}</div>
      <p class="balance">${{remainAmount || 0}}</p>
      <el-form
        class="elform"
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-form-item
          :label="amountLabel"
          prop="amount"
          class="has-prefix-item"
        >
          <el-input
            :placeholder="amountTips"
            v-model="form.amount"
          >
            <span slot="prefix">USD</span>
          </el-input>
          <p>{{$t('User.fee')}}: ${{fee}}</p>
        </el-form-item>
        <el-form-item
          :label="$t('Trade.payMoney')"
          prop="totalAmount"
          class="has-prefix-item"
        >
          <el-input
            disabled
            :value="getBillAmount()"
          >
            <span slot="prefix">{{currency}}</span>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getUSDExRateAndFee,
  getBankInfo,
} from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import {amountInputValidate, onlyTwoBitFloat} from "@/utils/validate";
import withdrawOrOutCommissionChanelCard from "@/components/public/withdrawChanel/withdrawOrOutCommissionChanelCard";
export default {
  name: "secondStepToChanel",
  components: {
    withdrawOrOutCommissionChanelCard,
  },
  props: {
    remainAmount: {
    },
    currentWithdrawInfo: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  data() {
    let _this = this;
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(_this.$t('please_input')));
      }else {
        if(!onlyTwoBitFloat(value)){
          callback(new Error(_this.$t('User.onlyInputTwoBitNumber')));
          _this.$emit('request-err');
          return;
        }else {
          if(+value < _this.currentWithdrawInfo.minimumLimit){
            callback(new Error(_this.$t('At_least_greater_than_the_minimum_withdrawal_amount',{type: _this.outType})));
          }else {
            callback();
          }
        }
      }
    };
    return {
      /*tips: [
        '1.请用与实际付款人姓名相同的银行卡进行转账。',
        '2.请不要习惯性转账，否则钱款可能无法追回。',
        '3.客户转账金额多于转账限额,款项打入了服务提供商的银行卡且难以追回，一切损失客户需要自行承担损失，公司不会提供任何补偿。',
      ],*/
      // 表单
      form: {
        amount: '',
      },
      rules: {
        amount: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
      },
      outMoney: {},
      keyvalue:""
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    fee(){
      if(this.currentWithdrawInfo.payTypeId == 4 || this.currentWithdrawInfo.payTypeId == 7){
        return 0;
      }else {
        return 1;
      }
    },
    currency(){
      return this.currentWithdrawInfo&&this.currentWithdrawInfo.payDetailMap&&this.currentWithdrawInfo.payDetailMap.currency?this.currentWithdrawInfo.payDetailMap.currency:"USD";
    },
    amountTips(){
      //
      return `≥${this.currentWithdrawInfo.minimumLimit}`
    },
    isWithdraw(){
      switch (this.currentWithdrawInfo.payTypeId){
        case 4:
        case 5:
        case 6:
          return true;
        default:
          return false;
      }
    },
    amountLabel(){
      if(this.isWithdraw){
        return this.$t('User.outAmount');
      }else {
        return this.$t('User.reportCommiAmount');
      }
    },
    outType(){
      if(this.isWithdraw){
        return this.$t('User.out');
      }else {
        return this.$t('Commission');
      }
    }
  },
  
  created(){
    
  },
  watch:{
    currency:{
      handler(newVal, oldVal) {
        // this.getUSDExRateAndFee();
      },
      deep:true
    }
  },
  methods: {
    getUSDExRateAndFee(func) {
      let parmas = {
        oprType: 2,
        depCurrency:this.currency
      };
      getUSDExRateAndFee(parmas).then((res) => {
        this.outMoney = res.data[0] ? res.data[0] : {};
        if(func){
          func();
        }
        this.keyvalue = Math.random().toString(36).substr(2, 10);
      });
    },
    getBillAmount(){
      if (this.currentWithdrawInfo.payTypeId == 4 || this.currentWithdrawInfo.payTypeId == 7){
        return (this.form.amount * this.outMoney.nominalExRateWithdraw).toFixed(2);
      }else {
        if(!this.form.amount || isNaN(+this.form.amount)){
          return 0;
        }
        return this.form.amount - 1;
      }
    },
    inputHandle(val){
      this.form.amount = amountInputValidate(val);
    },
    validate(){
      // 银行卡没有绑定或状态异常
      // usdt没有绑定
      // otc65没有绑定
      let channelCard = this.$refs.commissionChanelcard;
      if(channelCard.currentWithdrawInfo.payTypeId == 4 ||  channelCard.currentWithdrawInfo.payTypeId == 7){
        if (!channelCard.currentWithdrawInfo.payDetailMap.bankAccount || channelCard.currentWithdrawInfo.examineStatus == 1 || channelCard.currentWithdrawInfo.examineStatus == 2) {
          this.$vs.notify({
            text: this.$t('Unable_to_apply_due_to_incomplete_information_or_failed_review'),
            position: 'top-center',
            color: 'warning'
          })
          return;
        }
      }else if(channelCard.currentWithdrawInfo.payTypeId == 5 ||  channelCard.currentWithdrawInfo.payTypeId == 8){
        if (!this.currentWithdrawInfo.payDetailMap.address) {
          this.$vs.notify({
            text: this.$t('Unable_to_apply_due_to_incomplete_information_or_failed_review'),
            position: 'top-center',
            color: 'warning'
          })
          return;
        }
      }else if(channelCard.currentWithdrawInfo.payTypeId == 6 ||  channelCard.currentWithdrawInfo.payTypeId == 9){
        if (!this.currentWithdrawInfo.payDetailMap.address) {
          this.$vs.notify({
            text: this.$t('Unable_to_apply_due_to_incomplete_information_or_failed_review'),
            position: 'top-center',
            color: 'warning'
          })
          return;
        }
      }
      this.$refs.form.validate((valid) => {
        this.form.billAmount = this.getBillAmount();
        this.form.currency = this.currency;
        this.form.outMoney = this.outMoney;
        if(valid){
          // 重新联调 出佣
          this.$emit('validate-form-flag',this.form);
        }else {
          console.log('error');
        }
      })
    },
    //获取银行信息
    getWithdrawInfo(func) {
      getBankInfo({
        custId: this.userInfo.id,
        type: 1,
      }).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].payTypeId == this.$route.params.payTypeId){
            this.currentWithdrawInfo = res.data[i];
            break;
          }
        }
        this.getUSDExRateAndFee(func);
      })
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    addCollection(channelType){
      this.$emit('add-collection',channelType);
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.second-step-to-chanel {
  .bgc-bar {
    width: 360px;
    position: relative;
    left: -1.5rem;
    height: 12px;
    background-color: #F8F8F8;
  }
  .subtitle {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
    margin-bottom: 10px;
  }
  .tips-card {
    padding-top: 10px;
    padding-bottom: 15px;
    .tips-p {
      color: #5E5873;
    }
  }

  .account-inner {
    border: 1px solid #EBE9F1;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    &.active {
      border-color: $themeColor;
    }
    .account-top {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .login {
        padding-left: 10px;
        font-size: 14px;
        font-weight: 600;
        color: #6E6B7B;
      }
    }

    .inner-bot {
      padding-left: 30px;
      margin-top: 5px;
    }
    .small-icon {
      width: 24px;
      height: 24px;
    }
  }
  .balance {
    margin-bottom: 10px;
  }


  .nav-title {
    font-size: 16px;
    font-weight: 600;
    color: #5E5873;
    margin-top: 20px;
    margin-bottom: 10px;
    &.amount {
      margin-bottom: 5px;
    }
  }

  .payee-box {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid $themeColor;
    margin-bottom: 20px;
    .card-top {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon-img {
        width: 24px;
        height: 24px;
        margin-right: 15px;
      }
    }
    .bottom-line {
      padding-left: 40px;
      font-size: 14px;
    }

    // 空信息
    &.no-info {
      padding: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      .add-btn {
        padding-right: 10px;
      }
    }
  }

  .balance {
    font-size: 16px;
    font-weight: 600;
    color: #D85E5F;
  }

  .mobile-row {
    .el-dropdown,
    .account-inner {
      width: 100%;
    }
  }
  /deep/ .el-input__prefix {
    left: 15px;
  }
  /deep/ .el-input__inner {
    padding-left: 50px;
  }
}
</style>
